import * as React from 'react';
import {
  Menu, MenuItem,
} from '@material-ui/core';
import type { IGroupingActionMenuProps } from './MassReceiveInterfaces';

const GroupingActionMenu: React.FC<IGroupingActionMenuProps> = (
  {
    anchorEl, handleEditGrouping, handleDeleteGrouping, handleClose,
  },
) => (
  <Menu
    anchorEl={anchorEl}
    keepMounted
    open
    onClose={handleClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
  >
    <MenuItem id="edit-job-groupings-item" onClick={() => handleEditGrouping()}>{'Edit Job Grouping'}</MenuItem>
    <MenuItem id="delete-job-groupings-item" onClick={() => handleDeleteGrouping()}>{'Delete Job Grouping'}</MenuItem>
  </Menu>
);

export default GroupingActionMenu;
